import React from 'react';
import { AdminNavigation } from '../../components/Beehive/AdminNavigation.js';
import { Routes, Route } from 'react-router-dom';
import ResiliencePanel from '../../components/Beehive/ResiliencePanel.js';
import { useInternalDashSocket } from '../../hooks/useInternalDashSocket.js';

const InternalDashboardPage: React.FC = () => {
  const internalDashSocket = useInternalDashSocket({
    onMessage: (message) => {
      console.log('[InternalDashboard] Received WebSocket message:', message);
    },
    onMetricsUpdate: (metrics) => {
      console.log('[InternalDashboard] Received metrics update:', metrics);
    },
    onConnectionChange: (isConnected) => {
      console.log('[InternalDashboard] WebSocket connection status:', isConnected);
    },
    onOpen: () => {
      console.log('[InternalDashboard] WebSocket connection opened');
    },
    onError: () => {
      console.log('[InternalDashboard] WebSocket connection error');
    }
  });

  return (
    <div className="h-full bg-slate-900 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h1 data-devinid="internal-dashboard-header" className="text-3xl font-bold text-white">
            Internal Dashboard
          </h1>
          {/* Connection status indicator */}
          <div className="flex items-center space-x-2">
            <div className={`w-3 h-3 rounded-full ${internalDashSocket.isConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
            <span className="text-sm text-gray-400">
              {internalDashSocket.isConnected ? 'Connected' : 'Disconnected'}
            </span>
          </div>
        </div>
        <AdminNavigation prefix="/beehive/internal" />
        <div className="mt-8">
          <Routes>
            <Route path="resilience" element={<ResiliencePanel />} />
            {/* Add other internal panels here as needed */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default InternalDashboardPage;
